import { useState } from "react";
import { confirmationPath, confirmationSummary } from "./confirmation";
import { speakPersian } from "./audioGuidance";

interface ConfirmationSheetProps {
  title: string;
  parts: readonly string[];
  speechEnabled: boolean;
  fastConfirmEnabled: boolean;
  onConfirm(): void;
  onCancel(): void;
}

export function ConfirmationSheet({
  title,
  parts,
  speechEnabled,
  fastConfirmEnabled,
  onConfirm,
  onCancel,
}: ConfirmationSheetProps) {
  const [spoken, setSpoken] = useState(false);
  const summary = confirmationSummary(parts);

  function readSummary() {
    setSpoken(speakPersian(summary));
  }

  function confirm(fastRequested: boolean) {
    const path = confirmationPath({ speechEnabled, fastConfirmEnabled }, fastRequested);

    if (path === "speak_then_confirm" && !spoken) {
      readSummary();
      return;
    }

    onConfirm();
  }

  return (
    <section
      className="confirm-sheet"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
    >
      <h2 id="confirm-title">{title}</h2>
      <p className="confirm-summary">{summary}</p>
      <div className="confirm-actions">
        <button type="button" className="secondary-button large-button" onClick={onCancel}>
          لغو
        </button>
        {fastConfirmEnabled ? (
          <button
            type="button"
            className="secondary-button large-button"
            onClick={() => confirm(true)}
          >
            تأیید سریع
          </button>
        ) : null}
        <button
          type="button"
          className="primary-button large-button"
          onClick={() => confirm(false)}
        >
          {speechEnabled && !spoken ? "خواندن و تأیید" : "ثبت نهایی"}
        </button>
      </div>
    </section>
  );
}
